import { ReactNode } from 'react';
import './Nav.css'
import { getModeName } from '../../../utils/mavMode';

interface ModeBoxProps {
    type: number;
    mode: number;
    isOnline: boolean;
}

// Таблицы режимов переехали в utils/mavMode: их же использует сетка дронов.
function ModeBox({ type, mode, isOnline }: ModeBoxProps): ReactNode {
    return (
        <div className='mode-box'>{getModeName(type, mode, isOnline)}</div>
    )
}

export default ModeBox;
